import { Filters } from '../components/blog/helpers';

export const createBlogFilterKey = (type: keyof Filters, id: string) => `${type}-${id}`;

export const getBlogFilterIdAndTypeFromKey = (key: string) => {
  const [type, id] = key.split('-');

  return { type: type as keyof Filters, id };
};
